var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('input',{attrs:{"type":"file"},on:{"change":function($event){return _vm.uploadFileAsync($event)}}}),(_vm.uploadStatus)?_c('p',[_vm._v(_vm._s(_vm.uploadStatus))]):_vm._e(),(_vm.uploadProgress)?_c('p',[_vm._v("上传进度："+_vm._s(_vm.uploadProgress))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }